var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-hover", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ hover }) {
          return [
            _c(
              "v-container",
              {
                class: [
                  "pl-6 py-0 card-stemdoer",
                  {
                    "card-stemdoer--hover":
                      hover && _vm.cardOptions.isClickable === true,
                  },
                ],
                style: { opacity: _vm.cardOptions.isDisabled ? "0.7" : "1" },
                attrs: { "data-cy": "card-stemdoer" },
                on: {
                  click: function ($event) {
                    _vm.cardOptions.isClickable === true
                      ? _vm.onClick(_vm.stemdoer.id)
                      : ""
                  },
                },
              },
              [
                _c(
                  "v-row",
                  {
                    attrs: { "data-cy": "card-stemdoer-row", "no-gutters": "" },
                  },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "py-4",
                        attrs: { "data-cy": "stemdoer-info" },
                      },
                      [
                        _c(
                          "v-row",
                          {
                            staticClass: "mb-4",
                            attrs: {
                              "data-cy": "stemdoer-header",
                              "no-gutters": "",
                            },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "d-flex align-center mr-4",
                                attrs: {
                                  "data-cy": "avatar-stemdoer",
                                  cols: "auto",
                                },
                              },
                              [
                                _c("SAvatarStemdoer", {
                                  staticStyle: {
                                    height: "40px !important",
                                    width: "40px !important",
                                  },
                                  attrs: {
                                    stemdoId: _vm.stemdoer.stemdoId,
                                    size: "40px",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              [
                                _c(
                                  "v-row",
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    _c("v-col", [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-body-1 color-text-black",
                                          attrs: { "data-cy": "stemdoer-name" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.stemdoer.name +
                                                  " " +
                                                  _vm.stemdoer.surname.charAt(
                                                    0
                                                  ) +
                                                  "."
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { attrs: { "no-gutters": "" } },
                                  [
                                    _c("v-col", [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-body-1-bold color-text-black",
                                          attrs: {
                                            "data-cy": "stemdoer-position",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.stemdoer.position) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          {
                            attrs: {
                              "data-cy": "stemdoer-technologies",
                              "no-gutters": "",
                            },
                          },
                          _vm._l(
                            _vm.firstFourTechnologyScores,
                            function (tech, index) {
                              return _c(
                                "v-chip",
                                {
                                  key: index,
                                  staticClass: "mr-2",
                                  attrs: {
                                    "data-cy": "stemdoer-tech-" + index,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "technologyMaster.list." +
                                            tech.idTechnology
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              )
                            }
                          ),
                          1
                        ),
                        _vm._v(" "),
                        _vm.cardOptions.displayInterestTag === true
                          ? _c(
                              "v-row",
                              {
                                staticClass: "mt-4",
                                attrs: {
                                  "data-cy": "stemdoer-interest-tag",
                                  "no-gutters": "",
                                },
                              },
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("TagInterest", {
                                      attrs: {
                                        teamRequests: _vm.stemdoer.teamRequests,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-2",
                        attrs: { "data-cy": "stemdoer-actions", cols: "auto" },
                      },
                      [
                        _c(
                          "v-row",
                          {
                            staticStyle: { height: "34px" },
                            attrs: {
                              "data-cy": "stemdoer-delete-row",
                              justify: "end",
                              "no-gutters": "",
                            },
                          },
                          [
                            _vm.cardOptions.isDeletable
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      height: "18px",
                                      cursor: "pointer",
                                    },
                                    attrs: { "data-cy": "stemdoer-delete" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onDeleteClick(
                                          _vm.stemdoer.id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: "/content/svgs/close-grey.svg",
                                        alt: "Delete",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.cardOptions.isRateEditable
                          ? _c(
                              "v-row",
                              {
                                staticClass: "mr-2",
                                attrs: {
                                  "data-cy": "stemdoer-rate-editable",
                                  "no-gutters": "",
                                },
                              },
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "mb-2",
                                        attrs: {
                                          "data-cy":
                                            "stemdoer-hourly-rate-label",
                                          "no-gutters": "",
                                        },
                                      },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "text-subtitle-4 text--text text--lighten-1",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t("sCardStemdoer.hourlyRate")
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "input-background",
                                            attrs: {
                                              "data-cy": "stemdoer-rate-input",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                              },
                                            },
                                          },
                                          [
                                            _c("SInputNumber", {
                                              attrs: {
                                                value: _vm.rate,
                                                onChange: _vm.onRateChange,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-col", { staticClass: "ml-2" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "btn-data input-background",
                                              attrs: {
                                                "data-cy": "stemdoer-rate-data",
                                              },
                                            },
                                            [
                                              _c("v-img", {
                                                staticStyle: {
                                                  transform: "scale(0.8)",
                                                },
                                                attrs: {
                                                  width: 22,
                                                  src: "/content/svgs/data.svg",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.cardOptions.isRateVisible
                          ? _c(
                              "v-row",
                              {
                                staticClass: "mt-2 mr-4",
                                attrs: {
                                  "data-cy": "stemdoer-rate-visible",
                                  "no-gutters": "",
                                },
                              },
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c("v-col", [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-h5 text--text text--base",
                                              attrs: {
                                                "data-cy":
                                                  "stemdoer-rate-display",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.rate != null &&
                                                      !isNaN(_vm.rate)
                                                      ? _vm.$n(
                                                          _vm.rate,
                                                          "decimal"
                                                        ) + " €"
                                                      : "---"
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "text-subtitle-4 text--text text--lighten-1",
                                          attrs: {
                                            "data-cy": "stemdoer-rate-label",
                                          },
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t("sCardStemdoer.hourlyRate")
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.cardOptions.isRateEditable &&
                _vm.cardOptions.projects &&
                _vm.cardOptions.projects.length > 0
                  ? _c(
                      "v-row",
                      {
                        staticClass: "mr-2 mb-3",
                        attrs: {
                          "data-cy": "stemdoer-rate-editable",
                          "no-gutters": "",
                          align: "center",
                        },
                      },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "d-flex align-center pr-2",
                            staticStyle: { "min-width": "150px" },
                            attrs: { cols: "auto" },
                          },
                          [
                            _c("span", {
                              staticClass:
                                "text-subtitle-4 text--text text--lighten-1",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("sCardStemdoer.assignProjectOptional")
                                ),
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass: "input-background d-flex",
                            attrs: { "data-cy": "stemdoer-project-input" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [
                            _c("ProjectSelector", {
                              attrs: {
                                preSelectedProjectId: _vm.selectedProject,
                                "project-items": _vm.projectItems,
                                placeholder: _vm.$t(
                                  "sCardStemdoer.selectProjectPlaceholder"
                                ),
                                clearable: true,
                                "is-disabled": false,
                              },
                              on: { change: _vm.handleProjectChange },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }